import cx from 'classnames'
import _ from 'lodash'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { MdExpandMore } from 'react-icons/md'

import { useClickOutside } from '../../../../../hooks'
import styles from '../select.module.scss'

import { SelectItem } from './select-item'

export function Filter ({
  label,
  relation,
  itemType,
  handler,
  numbersOfSelected,
  lists
}) {
  const [ isOpen, setOpen ] = useState(false)
  const [ letter, setLetter ] = useState(null)
  const scrollViewRef = useRef(null)
  const wrapperRef = useRef(null)
  useClickOutside(wrapperRef, () => {
    setOpen(false)
  })

  const sortFn = useCallback((prev, next) => {
    const prevName = prev.name.toLowerCase()
    const nextName = next.name.toLowerCase()
    const _letter = letter.toLowerCase()
    const prevNameIndex = prevName.indexOf(_letter)
    const nextNameIndex = nextName.indexOf(_letter)
    if (prevNameIndex === -1) {
      return 1
    }
    if (nextNameIndex === -1) {
      return -1
    }
    if (prevNameIndex > nextNameIndex) {
      return 1
    } if (prevNameIndex < nextNameIndex) {
      return -1
    }
    return 0
  }, [ letter ])

  useEffect(() => {
    if (letter) {
      const sortedData = _.cloneDeep(lists)?.[itemType]?.sort(sortFn)
      if (sortedData[0]?.name) {
        const el = document.getElementById(sortedData[0].name)
        scrollViewRef.current.scrollTo({
          top: el.offsetTop,
          left: 0,
          behavior: 'smooth'
        })
      }
    }
  }, [ letter, lists, itemType, sortFn ])

  return (
    <button
      className={cx(styles.itemsWrapper)}
      ref={wrapperRef}
      tabIndex={0}
      onKeyDown={e => setLetter(e.key)}
    >
      <div
        className={cx(styles.typeSelect, styles.filter)}
        onClick={() => setOpen(s => !s)}
        aria-hidden='true'
      >
        <span className={styles.label}>{label}</span>
        <MdExpandMore size='1.2rem' />
      </div>
      {lists[itemType]?.length > 0 && (
        <div
          className={cx(styles.items, {
            [styles.filters]: isOpen,
            [styles.hide]: !isOpen
          })}
          ref={scrollViewRef}
        >
          {lists[itemType].map(element => (
            <SelectItem
              filter
              numbersOfSelected={numbersOfSelected}
              key={element.id}
              item={element}
              rel={relation}
              handleChecked={() => {
                handler(element.id, itemType)
              }}
            />
          ))}
        </div>
      )}
    </button>
  )
}
